import { useSelector } from "react-redux";
import styled from "styled-components";

import medallionsImage from "assets/enhancements.svg";
import { media } from "components/styles/breakpoints";
import { getMedallions } from "redux/selectors/characterSelectors";
import { COLORS } from "utils/constants";
import Tooltip from "./Tooltip";
import TooltipMedallions from "./TooltipMedallions";

interface BarValueProps {
  percentage: number;
}

const InfoWrapper = styled.div`
  width: 100%;
  height: 16px;
  user-select: none;
  transform: skew(-30deg);

  ${media.desktop`
    height: 20px;
  `}
`;

const MedallionsWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${COLORS.ENHANCEMENTS};
  height: 100%;
  transform: skew(30deg);
  position: relative;
`;

const MaxBarValue = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: ${COLORS.ENHANCEMENTS};
  filter: saturate(75%) brightness(75%);
  transform: skew(-30deg);
`;

const MaxNumber = styled.div`
  color: #00000060;
  font-size: 12px;
  font-weight: 600;
  z-index: 1;
  position: absolute;
  right: 0;
  margin-right: 6px;

  ${media.desktop`
    font-size: 16px;
    margin-right: 8px;
  `}
`;

const MedallionData = styled.div`
  padding: 0 8px 0 12px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  position: absolute;
  z-index: 2;
`;

const MedallionsNumber = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: white;
`;

const BarValue = styled.div.attrs(({ percentage }: BarValueProps) => ({
  style: {
    width: `${percentage}%`,
  },
}))<BarValueProps>`
  height: 100%;
  background-color: ${COLORS.ENHANCEMENTS};
  transition: all 200ms ease-out;
  transform: skew(-30deg);
`;

const Separator = styled.div`
  background-color: ${COLORS.ENHANCEMENTS};
  width: 1px;
  height: 100%;
  z-index: 2;
  transform: skew(-30deg);
  filter: saturate(120%) brightness(120%);
`;

const MedallionsIcon = styled.div`
  position: absolute;
  right: -20px;
  top: 4px;
  height: 14px;
  width: 14px;
  background-color: ${COLORS.ENHANCEMENTS};
  mask: url(${medallionsImage}) no-repeat center;
`;

export default function MedallionsInfo() {
  const medallions = useSelector(getMedallions);
  const totalSpent = medallions.statsSpent + medallions.skillsSpent;
  const spentStatsPercentage = (medallions.statsSpent / medallions.total) * 100;
  const spentSkillsPercentage =
    (medallions.skillsSpent / medallions.total) * 100;

  return (
    <InfoWrapper>
      <Tooltip color={COLORS.ENHANCEMENTS} content={<TooltipMedallions />}>
        <MedallionsWrapper>
          <MaxBarValue />
          <MaxNumber>{medallions.total}</MaxNumber>
          <BarValue percentage={spentStatsPercentage} />
          <Separator />
          <BarValue percentage={spentSkillsPercentage} />
          <MedallionData>
            <MedallionsNumber>{totalSpent}</MedallionsNumber>
          </MedallionData>
          <MedallionsIcon />
        </MedallionsWrapper>
      </Tooltip>
    </InfoWrapper>
  );
}
